export default __webpack_public_path__ + "static/media/Vivek-Raj.20ca55f6.png";